module.exports = __webpack_public_path__ + "img/9788994210407.e5ebe857.jpg";